import { useCookie } from '#imports'

export const useRecurringConsentCode = () => {
    const consentCode = useCookie<string | undefined>('recurring-consent:consentCode', {
        sameSite: 'lax',
        secure: true,
    })

    return {
        consentCode,
    }
}
